import type { Workflow } from '~/types/Workflow';

import { WorkflowIntegrationType } from '~/enums/WorkflowIntegrationType';

export const WELL_KNOWN_FIELD_ORDER = [
  'contract_title',
  'contract_description',
  'contract_type',
  'company',
  'supplier',
  'start_date',
  'end_date',
  'final_spend',
  'currency',
] as const;

type WellKnownFieldNames = (typeof WELL_KNOWN_FIELD_ORDER)[number];

export const HIDDEN_WELL_KNOWN_FIELD_KEYS = [
  'contract_record_unique_id_original',
] as const;

const visibleWhenNotWssOnlyIntegration = (workflow?: Workflow): boolean =>
  workflow?.integrationType !== WorkflowIntegrationType.WSS_ONLY;

/**
 * We want to hide certain well known fields when the workflow is a WSS only workflow.
 * As this is something that is likely to grow in the future, we're extracting it to a
 * single place, so we can easily add/remove constraints in the future.
 */
const WELL_KNOWN_FIELD_VISIBILITY_CONSTRAINTS: Partial<
  Record<WellKnownFieldNames, (workflow?: Workflow) => boolean>
> = {
  contract_type: visibleWhenNotWssOnlyIntegration,
  company: visibleWhenNotWssOnlyIntegration,
  currency: visibleWhenNotWssOnlyIntegration,
  final_spend: visibleWhenNotWssOnlyIntegration,
};

export function isWellKnownFieldVisible(
  fieldKey: string,
  workflow: Workflow | undefined,
): boolean {
  return (
    WELL_KNOWN_FIELD_VISIBILITY_CONSTRAINTS?.[
      fieldKey as WellKnownFieldNames
    ]?.(workflow) ?? true
  );
}
